import React, { useEffect, useRef, useState } from "react"
import styles from "@/components/Remedy/components/ScrollyBlock/ScrollyBlock.module.scss"
import { Box, Typography } from "@kohler-dsm-library/kohler-core"
import { handleVideoPlayedAnalytics } from "@/components/Remedy/components/analytics"

export const ScrollyBlock = () => {
  const [videoPercentagePlayed, setVideoPercentagePlayed] = useState(undefined)

  const videoContainerRef = useRef(null)

  useEffect(() => {
    if (!videoContainerRef.current) return

    const videoElement = videoContainerRef.current.querySelector("video")

    if (!videoElement) return

    const sourceVideo = videoElement.querySelector("source")

    videoElement.playbackRate = 0.5

    const handleTimeUpdate = () => {
      if (videoElement) {
        const percentagePlayed = Math.ceil(
          (videoElement.currentTime / videoElement.duration) * 100
        )
        setVideoPercentagePlayed(percentagePlayed)
      }
    }

    const handleIntersection = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          videoElement.play()
          handleVideoPlayedAnalytics(
            "Striking design",
            sourceVideo?.src,
            true,
            "scrollyvideo"
          )
        } else if (!videoElement.paused) {
          videoElement.pause()
        }
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: [0.6],
    })

    observer.observe(videoElement)

    videoElement.addEventListener("timeupdate", handleTimeUpdate)

    return () => {
      videoElement.removeEventListener("timeupdate", handleTimeUpdate)
      observer.unobserve(videoElement)
    }
  }, [])

  return (
    <Box
      className={styles["pxp-scrolly-container"]}
      component="section"
      mod="charcoal"
    >
      <div className={styles["__frame-holder"]}>
        <div className={styles["__text-frame-holder"]}>
          <div
            className={`${styles["__floating-container"]} ${styles["__first"]}`}
          >
            <div
              className={styles["__text-container"]}
              style={{
                opacity:
                  videoPercentagePlayed > 2 && videoPercentagePlayed < 27
                    ? 1
                    : 0,
                transform: `translateY(${
                  videoPercentagePlayed > 2 && videoPercentagePlayed < 27
                    ? 0
                    : 20
                }px)`,
              }}
            >
              <Typography
                className={styles["__title"]}
                size="h4"
                component="span"
              >
                Striking design
              </Typography>
              <Typography className={styles["__description"]} component="span">
                A sleek silhouette, dramatic lighting, and premium materials
                make a bold statement in any space.
              </Typography>
            </div>
          </div>

          <div
            className={`${styles["__floating-container"]} ${styles["__second"]}`}
          >
            <div
              className={styles["__text-container"]}
              style={{
                opacity:
                  videoPercentagePlayed > 30 && videoPercentagePlayed < 60
                    ? 1
                    : 0,
                transform: `translateY(${
                  videoPercentagePlayed > 30 && videoPercentagePlayed < 60
                    ? 0
                    : 20
                }px)`,
              }}
            >
              <Typography
                className={styles["__title"]}
                size="h4"
                component="span"
              >
                Centered on self-care
              </Typography>
              <Typography className={styles["__description"]} component="span">
                Every detail of the Ice Bath is all about helping develop your
                mental and physical resilience to become the best version of
                yourself.
              </Typography>
            </div>
          </div>
          <div
            className={`${styles["__floating-container"]} ${styles["__third"]}`}
          >
            <div
              className={styles["__text-container"]}
              style={{
                opacity:
                  videoPercentagePlayed > 66 && videoPercentagePlayed < 98
                    ? 1
                    : 0,
                transform: `translateY(${
                  videoPercentagePlayed > 66 && videoPercentagePlayed < 98
                    ? 0
                    : 20
                }px)`,
              }}
            >
              <Typography
                className={styles["__title"]}
                size="h4"
                component="span"
              >
                Engineered for optimal support
              </Typography>
              <Typography className={styles["__description"]} component="span">
                The ergonomic design ensures ideal body positioning, focusing on
                stability and alignment to enhance your experience.
              </Typography>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["__video-container"]}>
        <div
          ref={videoContainerRef}
          className={styles["__video-container-holder"]}
          dangerouslySetInnerHTML={{
            __html: `
          <video preload="metadata" muted loop playsinline autoplay id="scrollyvideo">
            <source src="https://kohler.scene7.com/is/content/${
              process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes("www.kohler.com")
                ? "kohlergbhprod"
                : "kohlergbhqa"
            }/PXP/ScrollyVideo.mp4" />
          </video>
        `,
          }}
        />
      </div>
    </Box>
  )
}
